<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('branches_overview.page_title') }}</slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="BranchOptions"
            btnViewPath="BranchesEdit"
            :table-columns="Columns"
            :page-size="100">
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'Name',
                      name: this.$t('branches_overview.columns.name'),
                      sortable: false
                  }
              ];
            }
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/branches/Overview.vue